import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-pagination-count',
  templateUrl: './pagination-count.component.html',
  styleUrls: ['./pagination-count.component.scss']
})
export class PaginationCountComponent implements OnInit {
  @Input() count: number;
  @Input() singularName: string;
  @Input() pluralName: string;

  constructor() { }

  ngOnInit(): void {
  }

}
